// extracted by mini-css-extract-plugin
module.exports = {"container":"containerLoader-module--container--d1yg9","spinner":"containerLoader-module--spinner--7Xgcd"};